import { createTopic } from '../lib';
import { z } from 'zod';

const extensionManagerNavigatedEventSchema = z.object({
  path: z.string(),
});

export type ExtensionManagerNavigatedEvent = z.infer<
  typeof extensionManagerNavigatedEventSchema
>;

export const extensionManagerNavigatedTopic =
  createTopic<ExtensionManagerNavigatedEvent>(
    {
      namespace: 'settings',
      name: 'extension-manager-navigated',
      description: 'Extension manager has been navigated',
    },
    extensionManagerNavigatedEventSchema,
  );
